(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-flash-sale]');
    if (!root) return;
    const outputs = root.querySelectorAll('[data-flash-countdown]');
    const istanbulParts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date()).reduce((parts, item) => {
      parts[item.type] = item.value;
      return parts;
    }, {});
    const end = Date.UTC(
      Number(istanbulParts.year),
      Number(istanbulParts.month) - 1,
      Number(istanbulParts.day) + 1
    ) - (3 * 60 * 60 * 1000) - 1000;
    const render = () => {
      const remaining = end - Date.now();
      if (remaining <= 0) {
        outputs.forEach((output) => { output.textContent = '00:00:00'; });
        root.classList.add('flash-sale--ended');
        return false;
      }
      const total = Math.floor(remaining / 1000);
      const hours = String(Math.floor(total / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
      const seconds = String(total % 60).padStart(2, '0');
      outputs.forEach((output) => { output.textContent = `${hours}:${minutes}:${seconds}`; });
      return true;
    };
    if (!render()) return;
    const timer = window.setInterval(() => {
      if (!render()) window.clearInterval(timer);
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
